
import * as __star__ from 'react-dom/client';

const {

createRoot,
hydrateRoot
} = __star__;

export {
createRoot,
hydrateRoot
};

